// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qv-1";
export var spinner = "_qv-0";